module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Bag#1-102a4ca395c29c820f41deac0c81b61e.svg";